module.exports = __webpack_public_path__ + "assets/lytx-camera.b4acf9aa.svg";